<div class="page-container content">
  <app-loading />
</div>

